<template>
  <header class="page-designers-header p-top-3 m-bot-3">
    <!-- Title -->
    <div class="row-1">
      <h1
        data-animate="header-title"
        v-if="header?.generalHeaderTitle"
        class="title-m page-designers-header__title"
      >
        {{ header.generalHeaderTitle }}
      </h1>
      <div
        v-if="header?.generalHeaderText"
        data-animate="header-content"
        class="page-designers-header__text text-l m-top-6"
        v-html="header.generalHeaderText"
      />
    </div>
  </header>
</template>

<script>
export default {
  name: 'PagesDesignersHeader',
}
</script>

<script setup>
const props = defineProps({
  header: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
